
import { Placement } from '@post-office/placements-frontend/adminhub-billing-preview-footer-section';
export default Placement;
